<div class="vf-lightbox-backdrop"
     #backdropEl
     [class.is-open]="open"
     role="dialog"
     aria-modal="true"
     [attr.aria-label]="dialogLabel"
     (click)="onBackdropClick($event)">

    <button type="button" class="vf-lightbox-close" #closeBtn
            *ngIf="open"
            aria-label="Close"
            tooltip="Close"
            placement="bottom"
            container="body"
            triggers="hover"
            (click)="close()">
        <lucide-icon name="x" [size]="22" [strokeWidth]="2" aria-hidden="true"></lucide-icon>
    </button>

    <!-- Polite live region: tells a screen reader whether the image is loading, shown or not
         available (the focus sits on Close meanwhile). Always in the DOM so changes are heard;
         visually hidden. -->
    <div class="vf-lightbox-sr-status" role="status" aria-live="polite">{{ statusText }}</div>

    <div class="vf-lightbox-stage" *ngIf="open">
        <!-- Image mode: when the file extension is image-like (or unset, for
             backwards compat) we attempt to load it inline. -->
        <ng-container *ngIf="isImageFile">
            <div *ngIf="loading" class="vf-lightbox-loading">
                <span class="vf-lightbox-spinner" aria-hidden="true"></span>
                <div>Loading preview…</div>
            </div>

            <img *ngIf="!loading && safeImageUrl && !imageLoadFailed"
                 class="vf-lightbox-image"
                 [src]="safeImageUrl"
                 [alt]="fileName || ''"
                 (error)="onImageError()" />

            <!-- `!safeImageUrl` is part of the condition, not just `imageLoadFailed`:
                 when the URL never resolved at all (proxy call failed, or the token
                 carries no url) there is no <img> to fire (error) on, so without it
                 the stage rendered EMPTY — an open lightbox showing only the file
                 name, with no way forward. -->
            <div *ngIf="!loading && (imageLoadFailed || !safeImageUrl)" class="vf-lightbox-error">
                <lucide-icon name="image" [size]="48" [strokeWidth]="1.5" aria-hidden="true"></lucide-icon>
                <div>Preview isn't available for this file.</div>
                <a *ngIf="webUrl || imageUrl" class="vf-lightbox-error-link" #errorLink
                   [href]="webUrl || imageUrl" target="_blank" rel="noopener noreferrer">
                    Open in new tab
                </a>
            </div>
        </ng-container>

        <!-- File-icon mode: shown for non-image extensions (pdf, docx, xlsx, etc).
             Per the spec, no thumbnail — just the file icon + name in a card. -->
        <div class="vf-lightbox-filecard" *ngIf="!isImageFile">
            <lucide-icon name="file-text" [size]="56" [strokeWidth]="1.25" aria-hidden="true"></lucide-icon>
            <div class="vf-lightbox-filecard-name">{{ fileName || '' }}</div>
            <button type="button" class="vf-lightbox-filecard-open" #fileOpenBtn
                    *ngIf="webUrl || imageUrl"
                    (click)="openExternal()">
                Open
            </button>
        </div>

        <div class="vf-lightbox-footer" *ngIf="fileName || fileSize">
            {{ footerText() }}
        </div>
    </div>
</div>
